import { t } from "i18next";

import SearchListItem from "./SearchListItem";
import { OrderIDList, SelectedDepType } from "utils/models/CommonTypes";

type Props = {
  pageList?: OrderIDList;
  page: number;
  selectedDep?: SelectedDepType;
  setSelectedDep: (v: SelectedDepType) => void;
  getIdentificationCard: Function;
};

const SearchTableMobile = ({
  pageList,
  selectedDep,
  page,
  setSelectedDep,
  getIdentificationCard,
}: Props) => {
  return (
    <>
      {pageList ? (
        <SearchListItem
          {...{
            isMobile: true,
            pageList,
            selectedDep,
            page,
            setSelectedDep,
            getIdentificationCard,
          }}
        />
      ) : (
        <div className="text-center">{t("noResult")}</div>
      )}
    </>
  );
};

export default SearchTableMobile;
